/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Appointment/view.blocks to change it.
import * as fromAggregate from 'Data/aggregate.js'
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromHelpers from './helpers.js'
import ActionsDialog from './ActionsDialog/index'
import AppointmentType from './AppointmentType/index'
import ConfirmedIcon from './ConfirmedIcon/index'
import InfoDialog from './InfoDialog/index'
import Notes from './Notes/index'
import PatientName from './PatientName/index'
import PaymentOverdueIcon from './PaymentOverdueIcon/index'
import React from 'react'
import StateIcon from './StateIcon/index'
import Time from './Time/index'
import TreatmentColors from './TreatmentColors/index'
import styles from './view.module.css'
import useIsHovered from 'Simple/hooks/useIsHovered'



/** @type {import('Simple/types.js').View} */
export default function Appointment({
  children,
  viewPath = "/DesignSystem/TimeGrid/FullCalendarTimegrid/Appointment",
  triggerRef,
  onMouseEnter,
  onMouseLeave,
  onMouseMove,
  hovered,
  top,
  left,
  contentRef,
  onMouseEnterContent
  
}) {
let [isHovered, isSelectedHovered, isHoveredBind] = useIsHovered({onMouseEnter,onMouseLeave})
let eventIdValueData = fromData.useDataValue({ viewPath,
context: 'event',
path: 'id',
})
let eventStateValueData = fromData.useDataValue({ viewPath,
context: 'event',
path: 'state',
})
let constantData = 'CHECKED_OUT'
let aggregateData = fromAggregate.equals(eventStateValueData, constantData)
let dtColorsWhite = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.white'
        })
let dtColorsNeutral300 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.300'
        })
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
let dtColorsNeutral100 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.100'
        })
let onClick = fromHelpers.useOnClick({
  children,
  viewPath,
  triggerRef,
  onMouseEnter,
  onMouseLeave,
  onMouseMove,
  hovered,
  top,
  left,
  contentRef,
  onMouseEnterContent
  
})
let onContextMenu = fromHelpers.useOnContextMenu({
  children,
  viewPath,
  triggerRef,
  onMouseEnter,
  onMouseLeave,
  onMouseMove,
  hovered,
  top,
  left,
  contentRef,
  onMouseEnterContent
  
})
let eventAppointmentTypeColorValueData = fromData.useDataValue({ viewPath,
context: 'event',
path: 'appointment_type_color',
})
let dtSpaceXxxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxxs'
        })
let dtSpaceMs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.ms'
        })
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
  return (<React.Fragment
>
<div
  data-testid="Appointment.Vertical"
  data-view-path={viewPath}
 id={eventIdValueData}
 ref={triggerRef}
 onMouseEnter={onMouseEnter}
 onMouseLeave={onMouseLeave}
 onMouseMove={onMouseMove}
 className={`views-block ${styles.Vertical}`}
>
<button
  data-testid="Appointment.Vertical:1"
  data-view-path={viewPath}
 {...isHoveredBind}
 onClick={onClick}
 onContextMenu={onContextMenu}
 style={{'--bc-2-dUIJ5': dtColorsNeutral300,'--bblr-3-dUIJ5': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--bbrr-4-dUIJ5': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--btlr-5-dUIJ5': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--btrr-6-dUIJ5': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--bc-1-dUIJ5': hovered ? dtColorsNeutral100 : dtColorsWhite,'--o-7-dUIJ5': aggregateData ? 0.7 : 1}}
 className={`views-block ${styles.Vertical1}`}
>
<div
  data-testid="Appointment.Vertical:2"
  data-view-path={viewPath}
 style={{'--pt-8-dUIJ5': typeof dtSpaceXxxs === 'number' ? `${dtSpaceXxxs}px` : dtSpaceXxxs,'--pr-9-dUIJ5': typeof dtSpaceMs === 'number' ? `${dtSpaceMs}px` : dtSpaceMs,'--pb-10-dUIJ5': typeof dtSpaceXxxs === 'number' ? `${dtSpaceXxxs}px` : dtSpaceXxxs,'--pl-11-dUIJ5': typeof dtSpaceMs === 'number' ? `${dtSpaceMs}px` : dtSpaceMs,'--blc-12-dUIJ5': eventAppointmentTypeColorValueData,'--blw-13-dUIJ5': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs}}
 className={`views-block ${styles.Vertical2}`}
>
<div
  data-testid="Appointment.Vertical:3"
  data-view-path={viewPath}
 className={`views-block ${styles.Vertical3}`}
>
<div
  data-testid="Appointment.Horizontal"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal}`}
>
<PatientName
  viewPath={`${viewPath}/PatientName`}
/>
<TreatmentColors
  viewPath={`${viewPath}/TreatmentColors`}
/>
</div>
<AppointmentType
  viewPath={`${viewPath}/AppointmentType`}
/>
<div
  data-testid="Appointment.Horizontal:1"
  data-view-path={viewPath}
 style={{'--g-14-dUIJ5': typeof dtSpaceXxxs === 'number' ? `${dtSpaceXxxs}px` : dtSpaceXxxs}}
 className={`views-block ${styles.Horizontal1}`}
>
<Time
  viewPath={`${viewPath}/Time`}
/>
<div
  data-testid="Appointment.Horizontal:2"
  data-view-path={viewPath}
 style={{'--g-14-dUIJ5': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs}}
 className={`views-block ${styles.Horizontal2}`}
>
<StateIcon
  viewPath={`${viewPath}/StateIcon`}
/>
<ConfirmedIcon
  viewPath={`${viewPath}/ConfirmedIcon`}
/>
<PaymentOverdueIcon
  viewPath={`${viewPath}/PaymentOverdueIcon`}
/>
</div>
</div>
</div>
<Notes
  viewPath={`${viewPath}/Notes`}
/>
</div>
</button>
<InfoDialog
  viewPath={`${viewPath}/InfoDialog`}
 top={top}
 left={left}
 contentRef={contentRef}
 onMouseEnter={onMouseEnterContent}
/>
<ActionsDialog
  viewPath={`${viewPath}/ActionsDialog`}
 top={top}
 left={left}
 contentRef={contentRef}
 onMouseEnter={onMouseEnterContent}
/>
</div>
{children}
</React.Fragment>)
}